import { Datagrid, FunctionField, List, TextField } from 'react-admin';
import moment from 'moment';
import MyPagination from '../MyPagination';

const AnonymousFeedbackList = () => {
	return (
		<List
			resource="anonymous-feedback"
			perPage={20}
			pagination={<MyPagination />}
			sort={{ field: 'createdAt', order: 'DESC' }}
			title="פניות אנונימיות"
		>
			<Datagrid bulkActionButtons={false} rowClick={false}>
				<FunctionField
					label="תאריך"
					render={(record: any) =>
						record?.createdAt ? moment(record.createdAt).format('DD/MM/YYYY HH:mm') : '-'
					}
				/>
				<FunctionField
					label="תוכן"
					render={(record: any) => (
						<span style={{ whiteSpace: 'pre-wrap', display: 'block', maxWidth: 700 }}>
							{record?.message ?? ''}
						</span>
					)}
				/>
				<TextField source="ip" label="IP" />
			</Datagrid>
		</List>
	);
};

export default AnonymousFeedbackList;
